import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import TickerContent from '../-components/content/TickerContent';

export const Route = createFileRoute('/_authenticated/tickers/$id/')({
    validateSearch: z.object({
        // The events after which a new event form is open
        eventIdsAfterToCreate: z.array(z.string()).optional().catch(undefined),
        // The events whose edit form is open
        eventIdsToEdit: z.array(z.string()).optional().catch(undefined),
        isEditingScoreboard: z.literal(true).optional().catch(undefined),
    }),
    component: TickerContent,
});
